import I18n from 'I18n';
import { Tab, Tabs } from 'foundations-components/transitional/components/Tabs';
import { useContext } from 'react';
import { EVENTS } from '../../../lib/events';
import { EnablementTrackingContext, WithEnablementTrackingProvider } from '../../../monitoring/EnablementTrackingContext';
import SRVSummarizedTable, { showSRVSummarizedTable } from '../fullPage/srv-table/SRVSummarizedTable';
import { SRVDatasetTable } from './dataset-tables/SRVDatasetTable';
import { useIsDatasetTableEnabledForReport } from './dataset-tables/useIsDatasetTableEnabledForReport';
import { SRVTableDisabledMessage } from './srv-table/SRVTableDisabledMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
// Must match the action types in events.yml for changeSrvTableTab
export const summarizedTable = 'srv-summarized-table';
export const unsummarizedDataset = 'srv-unsummarized-dataset';
export function SRVTablesInner({
  initialRowLimit,
  previewReport,
  onPreviewReportChange,
  refreshCount,
  reportErrorRenderer,
  suppressActionsBar = false
}) {
  const {
    enablementUsageTracker
  } = useContext(EnablementTrackingContext);
  const isDatasetTableEnabled = useIsDatasetTableEnabledForReport(previewReport);
  const isSummarizedTableEnabled = showSRVSummarizedTable(previewReport);
  if (!isSummarizedTableEnabled && !isDatasetTableEnabled) {
    return null;
  }
  function onChange(event) {
    enablementUsageTracker.track(EVENTS.changeSrvTableTab, {
      action: event.target.value
    });
  }
  return /*#__PURE__*/_jsxs(Tabs, {
    defaultSelected: isSummarizedTableEnabled ? summarizedTable : unsummarizedDataset,
    onSelectedChange: onChange,
    use: "enclosed",
    panelStyles: {
      paddingInline: '0'
    },
    children: [/*#__PURE__*/_jsx(Tab, {
      tabId: summarizedTable,
      title: I18n.text('reporting-enablement.singleReportViewer.tables.summarized'),
      children: isSummarizedTableEnabled ? /*#__PURE__*/_jsx(SRVSummarizedTable, {
        initialRowLimit: initialRowLimit,
        previewReport: previewReport,
        onPreviewReportChange: onPreviewReportChange,
        refreshCount: refreshCount,
        reportErrorRenderer: reportErrorRenderer,
        suppressActionsBar: suppressActionsBar
      }) : /*#__PURE__*/_jsx(SRVTableDisabledMessage, {
        message: I18n.text('reporting-enablement.singleReportViewer.tables.summarizedDisabled')
      })
    }), /*#__PURE__*/_jsx(Tab, {
      tabId: unsummarizedDataset,
      title: I18n.text('reporting-enablement.singleReportViewer.tables.dataset'),
      children: isDatasetTableEnabled ? /*#__PURE__*/_jsx(SRVDatasetTable, {
        previewReport: previewReport,
        suppressActionsBar: suppressActionsBar
      }) : /*#__PURE__*/_jsx(SRVTableDisabledMessage, {
        message: I18n.text('reporting-enablement.singleReportViewer.tables.datasetDisabled')
      })
    })]
  });
}
export const SRVTables = WithEnablementTrackingProvider(SRVTablesInner);